<div class="building-details-main" *ngIf="isEmpty">
  <app-empty-details [data]="message"></app-empty-details>
</div>

<div class="building-details-main mb-3 app-scrollbar" *ngIf="!isEmpty">
  <div class="row pt-4 pb-2 px-4">
    <div class="col-2 text-center">
      <img src="assets/svg/ico-building-with-black-circle.svg" class="icon" />
    </div>
    <div class="col-7 heading pl-2">
      <app-with-tooltip [showHelpCursor]="true">{{
        sharedData.selectedBuilding.buildingName
      }}</app-with-tooltip>
    </div>
    <div class="col-3 text-right setting-icon pointer-cursor">
      <img
        data-toggle="modal"
        data-target="#exampleModalCenter"
        (click)="openBuildingModal(true, false)"
        src="assets/svg/ico-lock-access-settings.svg"
      />
    </div>
  </div>
  <hr class="divider mx-4" />
  <div class="row px-4">
    <mat-button-toggle-group
      appearance="legacy"
      name="fontStyle"
      aria-label="Font Style"
      class="toggle-btns"
    >
      <mat-button-toggle
        class="btn"
        value="details"
        [ngClass]="{
          'btn-selected': selectedBtn === CONSTANTS.DETAILS
        }"
        (click)="btnToggle(CONSTANTS.DETAILS)"
        >{{ 'DETAILS' | translate }}</mat-button-toggle
      >
      <mat-button-toggle
        class="btn pointer-cursor"
        value="activity"
        [ngClass]="{
          'btn-selected': selectedBtn === CONSTANTS.ACTIVITY
        }"
        (click)="btnToggle(CONSTANTS.ACTIVITY)"
        >{{ 'ACTIVITY' | translate }}</mat-button-toggle
      >
    </mat-button-toggle-group>

    <div class="col-12 pb-3">
      <hr class="separator" />
    </div>
  </div>

  <app-floor-management
    [selectedBuilding]="sharedData?.selectedBuilding"
    [filter]="sharedData?.filter?.filterData"
    class="content mb-4 d-none"
    [class.d-block]="selectedBtn === CONSTANTS.DETAILS"
  ></app-floor-management>

  <div
    class="container-building-activity d-none"
    [class.d-block]="selectedBtn === CONSTANTS.ACTIVITY"
  >
    <app-activity
      [activities]="buildingActivities"
      (scrollDown)="scrollDownEmitter($event)"
      [canLoad]="canLoad"
      [activityType]="CONSTANTS.BUILDING"
      [commonAccessControl]="sharedData?.selectedSite?.commonAccessControl"
    >
    </app-activity>
  </div>
</div>
